import React from 'react'
import PropTypes from 'prop-types'

function BlogPostHero({ data }) {
  return (
    <div className="blog-post--hero">
      <img src={data.featuredImage?.file?.url} alt={data.featuredImage?.altText} />
      <div>
        <p className="blog-post--category">{data.categories}</p>
        <h1 className="blog-post--title">{data.postTitle}</h1>
        <p className="blog-post--byline">{data.author}</p>
        <p className="blog-post--date">{data.publishDate}</p>
      </div>
    </div>
  )
}

BlogPostHero.propTypes = {
  data: PropTypes.object.isRequired
}

export default BlogPostHero
